import { Component, inject } from '@angular/core';
import { CookieConsentService } from './services/cookie-consent.service';
import { ActivatedRoute, Data, NavigationEnd, Router } from '@angular/router';
import { filter, tap } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent {
  public showLandingPage = false;

  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly cookieConsent = inject(CookieConsentService);

  constructor() {
    // Check if default page
    const pageUrl = window.location.pathname;
    if (pageUrl.toString() == '/') {
      this.showLandingPage = true;
    } else {
      this.showLandingPage = false;
    }

    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd
        ),
        tap(() => {
          if (!this.isPreviewRoute()) {
            this.cookieConsent.initializeCookieConsent();
          }
        })
      )
      .subscribe();
  }

  private isPreviewRoute(): boolean {
    const routeData = this.getRouteData();

    if (!routeData) {
      return false;
    }

    return routeData['preview'] === true;
  }

  private getRouteData(): Data | undefined {
    return this.activatedRoute.snapshot.firstChild?.data;
  }
}
